<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Toast from 'primevue/toast'

import AppLayout from '@/layouts/AppLayout.vue'

const route = useRoute()

/** Екранът за вход се показва без обвивката — още няма дружество и потребител. */
const bare = computed(() => route.meta.layout === 'bare')
</script>

<template>
  <RouterView v-if="bare" />
  <AppLayout v-else>
    <RouterView />
  </AppLayout>

  <Toast position="bottom-right" />
</template>
